import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import MaterialTable from 'material-table';
import { Container } from '@material-ui/core';
import React, { useEffect, useState, useRef } from 'react';

import api from '../../../../services/api.js';

import Edit from './Components/Edit.js'

export default function MyTable(props) {
    const tableRef = useRef();
    const snack = useRef()
    const { enqueueSnackbar } = useSnackbar();
    snack.current = enqueueSnackbar

    const [uninas, setUsinas] = useState([]);

    const state = {
        columns: [
            {
                title: "Opções",
                field: "opcoes",
                render: (rowData) => {
                    return (
                        <Edit setData={props.setData} setOpen={props.setOpen} data={rowData} />
                    )
                }
            },
            { title: "Usina", field: "nome" },
            { title: "Nível de Resposta", field: "nivelResp" },
            { title: "Documento PAE", field: "paeb_pdf" },
            { title: "Status", field: "status" },
            { title: "e-Monitor", field: "e_monitor" },
            { title: "identificador", field: "_id" },
        ],
    };

    useEffect(() => {
        async function fetchData() {
            api.get(`/usinas`)
                .then((res) => {
                    setUsinas(res.data)
                })
                .catch((error) => {
                    console.log(error);
                    snack.current("Falha ao buscar usinas", { variant: 'error' })
                });
        }
        fetchData();
    }, [props.reload]);

    return (
        <Container maxWidth={false} spacing={2}>
            <MaterialTable
                tableRef={tableRef}
                title="Usinas"
                columns={state.columns}
                data={uninas}
                options={{
                    search: true,
                    pageSize: 10,
                    exportButton: false,
                    emptyRowsWhenPaging: false,
                    pageSizeOptions: [1, 5, 10, 20, uninas.length],
                    padding: "dense",
                    headerStyle: {
                        textAlign: "center",
                        color: "#b31b1b",
                    },
                    cellStyle: {
                        textAlign: "center",
                    },
                }}

                localization={{
                    body: {
                        emptyDataSourceMessage: "",
                        addTooltip: "adicionar novo",
                        deleteTooltip: "excluir",
                        editRow: { deleteText: "Deseja excluir?" },
                    },

                    header: {
                        actions: "Opções",
                    },

                    toolbar: {
                        searchTooltip: "Pesquisar",
                        searchPlaceholder: "Pesquisar",
                        exportTitle: "exportar",
                        nRowsSelected: "{0} Usuários(s) selecionados",
                    },
                    pagination: {
                        labelRowsSelect: "",
                        labelDisplayedRows: "{count} de {from}-{to}",
                        firstTooltip: "Primeira página",
                        previousTooltip: "Página anterior",
                        nextTooltip: "Próxima página",
                        lastTooltip: "Última página",
                    },
                }}
            />
        </Container >
    );
}

MyTable.propTypes = {
    reload: PropTypes.bool,
    setData: PropTypes.func,
    setOpen: PropTypes.func,
    setReload: PropTypes.func,
    setAffiliates: PropTypes.func,
};
